import * as Diagram from "../../../../components/diagram";
import { generateSerialArray } from "../../../common";
import moment from "moment";

export const ChronicDiseaseCountStatistic = {
  label: "個案慢性疾病數量分布統計",
  key: "ChronicDiseaseCountStatistic",
  path: "ElderlyHealth/ChronicDiseaseCountStatistic",
  api: "TCS_V_HealthVisitElderlyChronicDiseases",
  render: (options) => (
    <Diagram.ElderlyHealth.ChronicDiseaseCountStatistic {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  filterColumns: [
    {
      key: "noback_year",
      label: "篩檢年份",
      type: "singleDropdown",
      options: generateSerialArray(2023, Number(moment().format("YYYY"))).map(
        (item) => ({ label: item, value: item })
      ),
    },
  ],
  columns: [],
};
